import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Headline } from '@freenow/wave';

import { SignUpWrapper } from '../components/SignUpWrapper';

export const SignUpUnavailable = () => (
    <SignUpWrapper>
        <Box display="flex" textAlign="center">
            <Headline as="h3">
                <FormattedMessage id="signUp.pageUnavailable" />
            </Headline>
        </Box>
    </SignUpWrapper>
);
